import { useState } from "react";

const LinksByAudience = ({ linksMap }) => {
  const [expandedAudiences, setExpandedAudiences] = useState({});

  const toggleAudience = (audience) => {
    setExpandedAudiences(prev => ({
      ...prev,
      [audience]: !prev[audience]
    }));
  };

  if (!linksMap || Object.keys(linksMap).length === 0) return null;

  return (
    <div>
      {Object.entries(linksMap).map(([audience, links]) => (
        <div key={audience} className="audience-section">
          <div
            className="suggestion-toggle-row"
            onClick={() => toggleAudience(audience)}
            style={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              userSelect: "none",
              fontWeight: "bold",
              margin: "0.5em 0"
            }}
          >
            <span
              style={{
                display: "inline-block",
                transition: "transform 0.2s",
                transform: expandedAudiences[audience] ? "rotate(90deg)" : "rotate(0deg)",
                marginRight: "0.5em"
              }}
            >
              ▶
            </span>
            {audience}
          </div>
          {expandedAudiences[audience] && (
            <ul style={{ marginLeft: "2em" }}>
              {links.map((link, idx) => (
                <li key={link.url || idx}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer">
                    {link.title}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </div>
  );
}

export default LinksByAudience;
